/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import ValueOperatorType from './ValueOperatorType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueOperatorType (runtime) // new

/**
 * An individual value, could also be a null value. A null values translates in SQL to an IS NULL condition <p>Java class for valueType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="valueType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="operator" type="{}valueOperatorType"/&gt; &lt;element name="use" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="display" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="use2" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="display2" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ValueType extends MoserObject{

	operator = null;

	use = null;

	display = null;

	use2 = null;

	display2 = null;



	/**
	 * Gets the value of the operator property.
	 * @return {ValueOperatorType} possible object is {@link ValueOperatorType}
	 */
	getOperator() {
		return this.operator;
	}

	/**
	 * Sets the value of the operator property.
	 * @param {ValueOperatorType} value allowed object is {@link ValueOperatorType}
	 */
	setOperator(value) {
		var oldValue = this.operator;
		this.operator = value;
		this._setAndNotify(205, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the use property.
	 * @return {String} possible object is {@link String}
	 */
	getUse() {
		return this.use;
	}

	/**
	 * Sets the value of the use property.
	 * @param {String} value allowed object is {@link String}
	 */
	setUse(value) {
		var oldValue = this.use;
		this.use = value;
		this._setAndNotify(130, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the display property.
	 * @return {String} possible object is {@link String}
	 */
	getDisplay() {
		return this.display;
	}

	/**
	 * Sets the value of the display property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDisplay(value) {
		var oldValue = this.display;
		this.display = value;
		this._setAndNotify(181, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the use2 property.
	 * @return {String} possible object is {@link String}
	 */
	getUse2() {
		return this.use2;
	}

	/**
	 * Sets the value of the use2 property.
	 * @param {String} value allowed object is {@link String}
	 */
	setUse2(value) {
		var oldValue = this.use2;
		this.use2 = value;
		this._setAndNotify(203, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the display2 property.
	 * @return {String} possible object is {@link String}
	 */
	getDisplay2() {
		return this.display2;
	}

	/**
	 * Sets the value of the display2 property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDisplay2(value) {
		var oldValue = this.display2;
		this.display2 = value;
		this._setAndNotify(204, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ValueType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ValueType</code> object from.
	 * @return {ValueType} an object of type <code>ValueType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createValueType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ValueType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 205, "operator", ValueOperatorType));
		featureList.push(this.createFeature(false, false, false, 130, "use", null));
		featureList.push(this.createFeature(false, false, false, 181, "display", null));
		featureList.push(this.createFeature(false, false, false, 203, "use2", null));
		featureList.push(this.createFeature(false, false, false, 204, "display2", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 203:
			this.setUse2((value));
			break;
		case 204:
			this.setDisplay2((value));
			break;
		case 205:
			this.setOperator((value));
			break;
		case 130:
			this.setUse((value));
			break;
		case 181:
			this.setDisplay((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 203:
			return this.getUse2();
		case 204:
			return this.getDisplay2();
		case 205:
			return this.getOperator();
		case 130:
			return this.getUse();
		case 181:
			return this.getDisplay();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 203:
			return this.getUse2();
		case 204:
			return this.getDisplay2();
		case 205:
			return this.getOperator();
		case 130:
			return this.getUse();
		case 181:
			return this.getDisplay();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ValueType.js